import {Matcher} from '@/lib/axiosAddTransforms'
import {certStatusDict} from '../utils'

const eiSerializer = (data) => {
  return {
    ...data,
    statusCode: certStatusDict[data.status]
  }
}

const matchers: Matcher[] = [
  {
    test: /^\/ei\/?$/,
    method: 'get',
    transform: {
      request: (payload) => {
        const {bizId} = payload.data
        payload.url = `/bizs/${bizId}/3rd-party-services/ei`

        delete payload.data.bizId

        return payload
      },
      response: eiSerializer
    },
  },
  {
    test: /^\/ei\/?$/,
    method: 'post',
    transform: {
      request: (payload) => {
        const {bizId} = payload.data
        payload.url = `/bizs/${bizId}/subsidy/additional-youth/apply/`

        delete payload.data.bizIds

        return payload
      },
      response: (data) => data
    },
  },
]

export default matchers
